module.exports = __webpack_public_path__ + "img/About_8.a54d7737.png";